import clsx from 'clsx';
import React from 'react';

const Tag = ({ rarity, heading, label, children, className }) => {
  const rarityKey = rarity?.replace(' ', '');
  const rarities = {
    Common: 'text-gray-800 bg-gray-100',
    Uncommon: 'text-green-800 bg-green-100',
    Rare: 'text-blue-800 bg-blue-100',
    UltraRare: 'text-yellow-800 bg-yellow-100',
    Legendary: 'text-purple-800 bg-purple-100',
  };
  const rarityClass = rarities[rarityKey] || 'text-gray-100 bg-gray-700';

  return (
    <span className={clsx('inline-flex rounded-md px-2 py-0.5 text-xs font-medium flex-col justify-center', rarityClass, className)}>
      {heading && <span className='text-[10px] font-medium opacity-50 whitespace-nowrap'>{heading}</span>}
      {rarity || label || children}
    </span>
  );
};

export default Tag;
